import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}registro_patronal`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}registro_patronal/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}registro_patronal/${id}`);
  return response;
};
const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}registro_patronal`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}registro_patronal`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}registro_patronal/${id}`);
  return response;
};

const getPrimasByRegistroPatronalId = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}prima_riesgo/by/${id}`);
  return response;
};

const getPrimaRiesgo = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}prima_riesgo/${id}`);
  return response;
};

const insertPrimaRiesgo = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}prima_riesgo`, payload);
  return response;
};

const updatePrimaRiesgo = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}prima_riesgo`, payload);
  return response;
};

const dropPrimaRiesgo = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}prima_riesgo/${id}`);
  return response;
};

export { getAll, getList, getById, insert, update, drop, getPrimasByRegistroPatronalId, getPrimaRiesgo, insertPrimaRiesgo, updatePrimaRiesgo, dropPrimaRiesgo };
